import { render } from "./syemt.vue?vue&type=template&id=c4de3486"
import script from "./syemt.vue?vue&type=script&lang=js"
export * from "./syemt.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__